module.exports = __webpack_public_path__ + "static/media/fhz-small-th.6cb9effa.png";